import { render, staticRenderFns } from "./ComboPeriodoPagamento.vue?vue&type=template&id=4a31aa9c"
import script from "./ComboPeriodoPagamento.vue?vue&type=script&lang=js"
export * from "./ComboPeriodoPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports